module.exports = __webpack_public_path__ + "static/img/bcjt-logo.4a1988fa.jpg";